import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Loader.css';

//Component
import TextLoader from './TextLoader';
import FullPageLoader from './FullPageLoader';
import ButtonLoader from './ButtonLoader';
import CircleLoader from './CircleLoader';

function Loader(props) {

  const { type, loadingText, children, show, label } = props;
  const { buttonType, handleClick, className, disabled, spinnerColor, containerClass, image, tickIcon, tickIconStyle } = props;

  return (
    <div className={containerClass}>
      {
        type === "text" && <TextLoader loadingText={loadingText} />
      }
      {
        type === "page" && <FullPageLoader children={children} show={show} />
      }
      {
        type === "button" && <ButtonLoader
          label={label}
          show={show}
          type={buttonType}
          handleClick={handleClick}
          className={className}
          disabled={disabled}
          spinnerColor={spinnerColor}
          image={image}
          tickIcon={tickIcon}
          tickIconStyle={tickIconStyle}
        />
      }
      {
        type === "circle" && <CircleLoader show={show} />
      }
    </div>
  );
}

export default withStyles(s)(Loader);

